angular.module('SpidApp')

.constant('CurrencyHistoryAdapterConfig', {
  name : 'CurrencyHistory',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'currency_id',
    	distant : 'currency_id'
    }, {
    	local   : 'agency_id',
    	distant : 'agency_id'
    }, {
    	local   : 'rate_old',
    	distant : 'rate_old'
    }, {
    	local   : 'rate_new',
    	distant : 'rate_new'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})
